<template>
  <div class="container_box">
    <!--扫描贴单-->
    <div class="filter_box">
      <Form :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004083')">
              <Input
                :disabled="!getPermission('ymsContainerStatus_startChangeOrder')"
                :element-id="'scanning'"
                :placeholder="$t('key1004071')"
                @on-enter="enterScanInput"
                prefix="icon-scan"
                clearable
                v-model.trim="code">
              </Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002400')" prop="codeList">
              <Input type="textarea" :placeholder="$t('key1004072')"
                v-model.trim="pageParams.codeList"></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.status !== 4">
            <Form-item :label="$t('key1003158')" prop="workBy">
              <Select v-model="pageParams.workBy" style="width: 200px;" filterable>
                <Option v-for="item in updatedByList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="dropDownTimeList.length>0">
            <dropDownDateTime
              :transfer="false"
              ref="dropDownDateTime"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="content_box">
      <div class="flex align-items-center justify-content-between mb20">
        <div class="sort_options_box">
          <span>{{ $t('key1004074') }}</span>
          <local-tabButton :tabButtonList="stickerStatusList" @selectStatus="stickerStatusBtn"></local-tabButton>
        </div>
        <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsContainerStatus_changingOrderExport')">
          <Button type="primary">
            <span>{{ $t('key1003082') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="table_box">
        <Table
          ref="selection"
          highlight-row
          border
          max-height="500"
          :loading="tableLoading"
          :columns="tableColumns"
          @on-selection-change="tableChange"
          :data="tableData">
        </Table>
        <Page
          :transfer="true"
          v-if="!tableLoading"
          :total="total"
          @on-change="changePage"
          show-total
          :page-size="pageParams.pageSize"
          show-elevator
          :current="pageParams.pageNum"
          show-sizer
          @on-page-size-change="changePageSize"
          placement="top"
          :page-size-opts="pageArray">
        </Page>
      </div>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1004084')"
      paramKeyColums="ymsContainerChangeOrderExportColumns"
      :dimensionTypeList="dimensionTypeList"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownDateTime from "@/components/common/dropDownDateTime";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import {getUserNameByUserId, pageJump, getYmsUserWarehouseOpersUserName, getEnableWarehouseData, getWarehouseName, getAllUsersInfo} from "@/utils/common";

export default {
  name: "commoditySticker",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      code: '',
      pageParams: {
        codeList: '',
        status: 0,
        workBy: null,
        workEndTimeDown: null,
        workEndTimeUp: null,
        workStartTimeDown: null,
        workStartTimeUp: null,
        ymsWarehouseId: 'null', // 所属仓库
        pageNum: 1,
        pageSize: 15,
      },
      total: 0,
      tableColumns: [],
      tableData: [],
      stickerTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004052'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let text = '';
            v.stickerStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004053'),
          key: 'goodProductQuantity',
          align: 'center',
          sortable: true,
          render(h, params) {
            let ymsContainerGoodsCheckList = params.row.ymsContainerGoodsCheckList;
            let totalGoodProductQuantity = ymsContainerGoodsCheckList.reduce((pre, quantity) => {
              return pre + quantity.goodProductQuantity;
            }, 0);
            return h('span', totalGoodProductQuantity);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 150,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004075'),
                    show: v.getPermission('ymsContainerStatus_startChangeOrder'),
                    clickFn: () => {
                      v.$router.push({
                        path: '/commodityStickerOperation',
                        query: {
                          code: params.row.code
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], // 待贴单
      stickeringTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004052'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let text = '';
            v.stickerStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004053'),
          key: 'goodProductQuantity',
          align: 'center',
          sortable: true,
          render(h, params) {
            let ymsContainerGoodsCheckList = params.row.ymsContainerGoodsCheckList;
            let totalGoodProductQuantity = ymsContainerGoodsCheckList.reduce((pre, quantity) => {
              return pre + quantity.goodProductQuantity;
            }, 0);
            return h('span', totalGoodProductQuantity);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'),
          key: 'startTime',
          sortable: true,
          align: 'center',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.startTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'workBy',
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.workBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 150,
          render(h, params) {
            let talg = v.userInfo.userId === params.row.workBy && v.getPermission('ymsContainerStatus_startChangeOrder');
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004076'),
                    show: talg,
                    clickFn: () => {
                      v.$router.push({
                        path: '/commodityStickerOperation',
                        query: {
                          code: params.row.code
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], // 贴单中
      stickeredTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004052'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let text = '';
            v.stickerStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004053'),
          key: 'goodProductQuantity',
          align: 'center',
          sortable: true,
          render(h, params) {
            let ymsContainerGoodsCheckList = params.row.ymsContainerGoodsCheckList;
            let totalGoodProductQuantity = ymsContainerGoodsCheckList.reduce((pre, quantity) => {
              return pre + quantity.goodProductQuantity;
            }, 0);
            return h('span', totalGoodProductQuantity);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'),
          key: 'startTime',
          sortable: true,
          align: 'center',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.startTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057'),
          key: 'endTime',
          sortable: true,
          align: 'center',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.endTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004058'),
          key: 'timer',
          align: 'center',
          render: (h, params) => {
            let startTime = v.$uDate.dealTime(params.row.startTime, 'fulltime');
            let endTime = v.$uDate.dealTime(params.row.endTime, 'fulltime');
            if (endTime && startTime) {
              let timeStamp = (new Date(endTime).getTime() - new Date(startTime).getTime()) / 1000;
              return h('span', v.$uDate.timeStampTime(timeStamp));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'workBy',
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.workBy, v.userInfoList));
          }
        }
      ], // 已贴单
      updatedByList: [],
      defaultSelectValue: 1,
      dropDownTimeList: [],
      stickerStatusList: [],
      warehouseList: [],
      dimensionTypeList: [
        {value: 1, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004059')},
        {value: 2, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004060')}
      ],
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'code', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387')},
            {paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004052')},
            {paramKey: 'goodsQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004053')},
            {paramKey: 'SKU', paramValue: 'SKU'},
            {paramKey: 'skuQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004061')},
            {paramKey: 'changeOrderStartTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054')},
            {paramKey: 'changeOrderEndTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057')},
            {paramKey: 'dateLength', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004058')},
            {paramKey: 'updatedBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292')}
          ]
        }
      ],
      userInfoList:{}
    };
  },
  mounted() {
    let v = this;
    v.$nextTick(() => {
      v.getFocus('scanning');
    });
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.updatedByList = [];
      let roleList = this.$store.state.roleList;
      let newList = [];
      let list = [
        {selected: false, value: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004077'), jurisdictionKey: 'ymsContainerStatus_queryChangeOrderList'},
        {selected: false, value: 5, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004078'), jurisdictionKey: 'ymsContainerStatus_queryChangingOrderList'},
        {selected: false, value: 6, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004079'), jurisdictionKey: 'ymsContainerStatus_queryChanggedOrderList'},
      ];
      list.map((item) => {
        if (roleList[item.jurisdictionKey]) {
          newList.push(item);
        }
      });
      list[0].selected = true;
      this.stickerStatusList = list;
      this.warehouseList = [];
      (async () => {
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await getEnableWarehouseData(1).then((data) => {
          if (data.length > 0) {
            this.warehouseList = [{ymsWarehouseId: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')}, ...data];
          }
        });
        // 查询商户下拥有所有授权仓库的用户
        await getYmsUserWarehouseOpersUserName(this.userInfo.userId).then((data) => {
          if (data) {
            for (let key in data) {
              this.updatedByList.push(data[key]);
            }
          }
        });
        if (this.getPermission('ymsContainerStatus_queryChangeOrderList')) {
          this.pageParams.status = 4;
          await this.getStickerList();
        } else if (this.getPermission('ymsContainerStatus_queryChangingOrderList')) {
          this.pageParams.status = 5;
          await this.getStickeringList();
        } else if (this.getPermission('ymsContainerStatus_queryChanggedOrderList')) {
          this.pageParams.status = 6;
          await this.getStickeredList();
        }
        await this.getPastingBillOptions();
      })();
    },
    // 容器编号的回车键
    enterScanInput() {
      let v = this;
      if (v.code !== '') {
        v.axios.get(api.get_ymsContainerStatus_startChangeOrder + `?code=${v.code}`).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.$router.push({
                path: '/commodityStickerOperation',
                query: {
                  code: v.code
                }
              });
            }
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004080'));
        return false;
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.codeList = v.sepCommasFn(v.pageParams.codeList, [',', '，', '\n']);
      params.ymsWarehouseId = v.pageParams.ymsWarehouseId === 'null' ? null : v.pageParams.ymsWarehouseId;
      return params;
    },
    // 获取待贴单数据
    getStickerList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsContainerStatus_queryChangeOrderList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsContainerStatus_queryChangeOrderList, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取贴单中数据
    getStickeringList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsContainerStatus_queryChangingOrderList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsContainerStatus_queryChangingOrderList, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.tableData = list;
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取已贴单的数据
    getStickeredList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsContainerStatus_queryChanggedOrderList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsContainerStatus_queryChanggedOrderList, v.handleParameter()).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.code = '';
      v.$refs['pageParams'].resetFields();
      v.changeInput(1);
      if (v.pageParams.status === 6) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.pageParamsStatus = true;
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      });
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      let v = this;
      v.defaultSelectValue = value;
      v.$nextTick(() => {
        if (v.$refs['dropDownDateTime']) {
          v.$refs['dropDownDateTime'].timeList = [];
        }
      });
      v.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        v.pageParams[startTimeKey] = null;
        v.pageParams[endTimeKey] = null;
      });
      v.$forceUpdate();
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 选取容器状态
    stickerStatusBtn(index, value) {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pageParams.status = value;
      v.stickerStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
      if (v.pageParams.status === 6) {
        v.changeInput(1);
        setTimeout(() => {
          v.setDefaultTimerParams('three_months', 1);
          v.pageParamsStatus = true;
        }, 500);
      } else {
        v.changeInput(1);
        v.pageParamsStatus = true;
      }
      v.$forceUpdate();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsContainerStatusId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsContainerStatusIds = v.selectTableData;
      } else {
        query.ymsContainerStatusIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          query.exportType = obj.dimensionType;
          v.axios.post(api.post_ymsContainerStatus_changingOrderExport, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 根据状态处理列表字段和筛选条件
    handleFilter(data) {
      let v = this;
      v.tableColumns = [];
      v.dropDownTimeList = [];
      let filterTimeList = [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'), value: 1, parameterKey: ['workStartTimeUp', 'workStartTimeDown']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057'), value: 2, parameterKey: ['workEndTimeUp', 'workEndTimeDown']}
      ];
      data.map((item) => {
        if (item.selected) {
          if (item.value === 4) {
            v.tableColumns = v.stickerTableColumns;
            v.dropDownTimeList = [];
            v.$forceUpdate();
          } else if (item.value === 5) {
            v.tableColumns = v.stickeringTableColumns;
            v.dropDownTimeList = filterTimeList.slice(0, 1);
            v.$forceUpdate();
          } else {
            v.tableColumns = v.stickeredTableColumns;
            v.dropDownTimeList = filterTimeList;
            v.$forceUpdate();
          }
        }
      });
    },
    // 查询当前用户是否有正在贴单中的操作
    getPastingBillOptions() {
      let v = this;
      v.axios.get(api.get_ymsContainerStatus_getChangingOrder + `?userId=${v.userInfo.userId}`).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let code = data.code;
            if (code && v.getPermission('ymsContainerStatus_startChangeOrder')) {
              v.$Modal.confirm({
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004081'),
                content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004082'),
                onOk: () => {
                  v.$router.push({
                    path: '/commodityStickerOperation',
                    query: {
                      code: code
                    }
                  });
                },
                onCancel: () => {
                }
              });
            }
          }
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        if (v.pageParams.status === 4) {
          v.getStickerList();
        } else if (v.pageParams.status === 5) {
          v.getStickeringList();
        } else if (v.pageParams.status === 6) {
          v.getStickeredList();
        }
        v.pageParamsStatus = false;
      }
    },
    // 监听容器状态
    stickerStatusList: {
      handler(data) {
        let v = this;
        v.handleFilter(data);
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    dropDownDateTime,
    exportFieldsModal
  }
};
</script>

<style lang="less" scoped>
.filter_box /deep/ .ivu-form-item {
  margin: 0 !important;
}

.content_box {
  padding: 15px 15px 10px 15px;
  background-color: #fff;
  border-radius: 3px;
}

.table_box {
  background-color: #fff;

  /deep/ .ivu-tabs-bar {
    padding: 0 25px;
  }

  /deep/ .ivu-tabs-content {
    padding: 10px 25px 25px 25px;
  }
}
</style>
